import * as React from 'react'
import MoneySlider from 'components/slider'
import CountUp from 'react-countup'
import Results from 'components/results'
import './styles.scss'
import 'firebase/database'

interface Props {
    id: number,
    articleId: string,
    income: number,
    spent: number,
    default: number,
    title: string,
    onChange: (value:number[]) => void,
    onValidate: (value:number) => void,
    showGhost: boolean
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IState {
    userInput: boolean,
    income: number,
    spent: number,
    spendings: number,
    remains: number,
    showOthers: boolean,
    usersValues: number[]
}

export default class MoneyLeftOver extends React.Component<Props, IState> {
    constructor(props: any){
        super(props)
        this.validate = this.validate.bind(this)
        this.state = {
            userInput: false,
            income: this.props.income,
            spent: 0,
            spendings: this.props.spent - 1,
            remains: this.props.income,
            showOthers: false,
            usersValues: [0, 0, 0]
        }
    }

    private validate(value:number):void {
        this.setState({showOthers: true})
        this.props.onValidate(value)
    }

    public render() {
        return (
            <div className='moneyLeftContainer'>
                {!this.state.showOthers && (
                    <>
                        <div className='ui text container'>
                            <p className='special' style={{color: '#ad427f'}} >
                                Il vous reste {' '}
                                <b><CountUp
                                    delay={0}
                                    start={this.state.spent ? this.state.remains : (this.props.income - this.props.spent)}
                                    end={this.props.income - this.state.spent - this.state.spendings}
                                    onEnd={() => {
                                        this.setState({
                                            remains: this.props.income - this.state.spent - this.state.spendings})
                                    }}
                                /></b> <small>CHF</small>
                            </p>
                        </div>
                        <div className='ui container' style={{position: 'relative', display: 'block', marginTop: '0px'}}>
                            <MoneySlider
                                showGhost={this.props.showGhost}
                                income={this.props.income}
                                spent={this.props.spent}
                                default={this.props.default}
                                onSlideEnd={(value: number[]) => {
                                    this.props.onChange(value)
                                    this.setState({
                                        userInput: true,
                                        spent: value[2] - value[1] - 1,
                                        spendings: value[1]})
                                }}
                            />
                        </div>
                        <div className='ui container' style={{marginTop: '1.5em', textAlign: 'center'}}>
                            <div
                                className={'ui purple button' + (this.state.userInput ? '' : ' disabled')}
                                onClick={() => {
                                    this.validate(this.state.spent)
                                }}
                            >Ce que les autres ont répondu</div>
                        </div>
                    </>
                )}
                <div style={{position: 'relative', display: 'block', marginTop: '0px'}}>
                    {this.state.showOthers && (
                        <Results
                            question={this.props.id}
                            title={this.props.title}
                            income={this.props.income}
                            spent={this.state.spent}
                            spendings={this.state.spendings}
                            usersValues={this.state.usersValues}
                        />
                    )}
                </div>
            </div>
        );
    }
}